import { useQuery } from "@tanstack/react-query";
import Table from "../common/Table";
import Button from "../common/Button";
import { projectService } from "../../services/projects";

const ProjectList = ({ filters, onEdit, onDelete }) => {
  const { data: projects, isLoading } = useQuery({
    queryKey: ["projects", filters],
    queryFn: () => projectService.getAll(filters),
  });

  const columns = [
    { header: "Name", accessor: "name" },
    { header: "Client", accessor: (row) => row.client?.name },
    { header: "Progress", accessor: (row) => `${row.progress}%` },
    { header: "Status", accessor: "status" },
  ];

  const actions = (row) => (
    <>
      <Button
        variant="secondary"
        className="mr-2"
        onClick={() => onEdit(row)}
      >
        Edit
      </Button>
      <Button
        variant="danger"
        onClick={() => onDelete(row._id)}
      >
        Delete
      </Button>
    </>
  );

  if (isLoading) return <div>Loading...</div>;

  return <Table columns={columns} data={projects} actions={actions} />;
};

export default ProjectList;
